import React, { PureComponent } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Label,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  Button,
  Fade,
  FormText,
} from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';
import { string, func } from 'prop-types';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

class InputReadOnlyWithCopy extends PureComponent {
  static propTypes = {
    value: string.isRequired,
    id: string.isRequired,
    bottomText: string,
    handleClose: func,
  };

  static defaultProps = {
    value: '',
  };

  state = {
    copied: false,
  };

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleCopy = () => {
    this.setState(
      () => ({ copied: true }),
      () => {
        setTimeout(() => {
          this._mounted && this.setState(() => ({ copied: false }));
        }, 1200);
      },
    );
  };

  render() {
    const { copied } = this.state;
    const { value, id, bottomText, handleClose } = this.props;

    return (
      <FormGroup className="form-group-upper-label">
        <Label>
          <FMessage id={id} />
        </Label>
        <InputGroup>
          <Input value={value} readOnly />
          <InputGroupAddon addonType="append">
            {handleClose && (
              <Button type="button" color="transparent" onClick={handleClose}>
                <FMessage id="main.cancel" />
              </Button>
            )}
            <CopyToClipboard text={value} onCopy={this.handleCopy}>
              <Button type="button" color="primary" onClick={this.handleClick} disabled={!value}>
                {copied ? (
                  <Fade in={copied} tag="span" className="copy-message">
                    <SVG
                      src={`${STATIC_PATH}/img/action-icons/check.svg`}
                      height="20"
                      width="20"
                      cacheRequests
                    />
                    <FMessage id="main.copied" />
                  </Fade>
                ) : (
                  <>
                    <SVG
                      src={`${STATIC_PATH}/img/action-icons/copy.svg`}
                      height="20"
                      width="20"
                      cacheRequests
                    />
                    <FMessage id="main.copy" />
                  </>
                )}
              </Button>
            </CopyToClipboard>
          </InputGroupAddon>
        </InputGroup>
        {bottomText && (
          <FormText color="muted">
            <FMessage id={bottomText} />
          </FormText>
        )}
      </FormGroup>
    );
  }
}

export default InputReadOnlyWithCopy;
